// extracted by mini-css-extract-plugin
export default {"banner":"banners_banner__crpdL","bannerVideo":"banners_bannerVideo__OBOob"};